import React from 'react';

import { Thumbnail } from '../Thumbnail';

import { tokens } from './AssetDetails.tokens';

import { AssetName, CollectionName, StyledAssetDetails, TextGroup, ThumbnailWrapper } from './AssetDetails.style';

export interface AssetDetailsProps {
    // TODO: We should include `asset/collection` URLs.
    name: string;
    collectionName?: string;
    imageUrl?: string;
    size?: 'medium' | 'large';
}

export function AssetDetails({ name, collectionName, imageUrl, size = 'medium' }: AssetDetailsProps) {
    const collectionNameMarkup = collectionName?.length ? <CollectionName>{collectionName}</CollectionName> : null;

    return (
        <StyledAssetDetails $size={size}>
            <ThumbnailWrapper>
                <Thumbnail
                    // Should have a `title` (alt text)
                    imageUrl={imageUrl}
                    mashWidth={tokens.thumbnail.size.large * 2}
                />
            </ThumbnailWrapper>

            <TextGroup>
                <AssetName>{name}</AssetName>
                {collectionNameMarkup}
            </TextGroup>
        </StyledAssetDetails>
    );
}
